import PermitMarketplacePage from "./permitMarketplace";

export default PermitMarketplacePage;